// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","top":"Footer_top__cag5u","social_links_container":"Footer_social_links_container__xClHv","bottom":"Footer_bottom__7buk6"};